/***************************************************************************************************
 * Zone JS es requerido por Angular.
 */
import 'zone.js';  // Incluido con Angular CLI
